import { IIcon } from '@/types/generalTypes';

const TargetIcon = ({ className }: IIcon) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0001 18.3333C14.6025 18.3333 18.3334 14.6023 18.3334 9.99996C18.3334 5.39759 14.6025 1.66663 10.0001 1.66663C5.39771 1.66663 1.66675 5.39759 1.66675 9.99996C1.66675 14.6023 5.39771 18.3333 10.0001 18.3333Z'
        stroke='currentColor'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.0001 15C12.7615 15 15.0001 12.7614 15.0001 9.99996C15.0001 7.23854 12.7615 4.99996 10.0001 4.99996C7.23866 4.99996 5.00008 7.23854 5.00008 9.99996C5.00008 12.7614 7.23866 15 10.0001 15Z'
        stroke='currentColor'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.0001 11.6666C10.9206 11.6666 11.6667 10.9204 11.6667 9.99996C11.6667 9.07948 10.9206 8.33329 10.0001 8.33329C9.07961 8.33329 8.33341 9.07948 8.33341 9.99996C8.33341 10.9204 9.07961 11.6666 10.0001 11.6666Z'
        stroke='currentColor'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TargetIcon;
